import { defineComponent, PropType } from "vue";

export const LogsToolbar = defineComponent({
    props: {
        filterMode: {
            type: String as PropType<"structured" | "expression">,
            required: true,
        },
        filterExpression: {
            type: String,
            required: true,
        },
        filtersCount: {
            type: Number,
            required: true,
        },
        realtimeEnabled: {
            type: Boolean,
            required: true,
        },
        filterLabel: {
            type: String,
            required: true,
        },
        onopenFilters: {
            type: Function as PropType<() => void>,
            required: true,
        },
        ontoggleRealtime: {
            type: Function as PropType<() => void>,
            required: true,
        },
    },

    setup(props) {
        return () => {
            const hasActiveFilter = props.filterMode === "expression"
                ? Boolean(props.filterExpression.trim())
                : props.filtersCount > 0;

            return (
                <div class="log-toolbar">
                    <button class={{ "log-navbar": true, active: hasActiveFilter }} onClick={props.onopenFilters}>
                        <span class="material-symbols-outlined">{props.filterMode === "expression" ? "data_object" : "filter_alt"}</span>
                        {props.filterLabel}
                    </button>

                    <button class={{ "log-navbar": true, active: props.realtimeEnabled }} onClick={props.ontoggleRealtime}>
                        <span class="material-symbols-outlined">{props.realtimeEnabled ? "sync" : "sync_disabled"}</span>
                        Temps réel
                    </button>
                </div>
            );
        };
    },
});
